/* eslint-disable */
/**
 * SocketKeepAlive helper class for notifying parent class when an elapsed interval
 * time has occured without having seen a heartbeat.
 *
 * This is useful for when wanting to keep a WebSocket alive.
 */
class SocketKeepAlive {
  constructor(options) {
    const noop = () => {};

    this.keepAliveCallback = options.keepAliveCallback || noop;
    this.isAliveCallback = options.isAliveCallback || noop;
    this.intervalTime = options.intervalTime || 60000;
    this.isActive = true;

    this.heartBeat();
  }

  /**
   * Heartbeat function when called resets setInterval deferring the need to call the
   * keepAlive callback from occurring.
   */
  heartBeat = () => {
    if (!this.isActive) {
      this.isActive = true;
      this.isAliveCallback();
    }

    clearInterval(this.interval);
    this.interval = setInterval(this.keepAlive, this.intervalTime);
  };

  /**
   * KeepAlive function notifies caller via keepAliveCallback that the last
   * heart beat seen has surpassed the elapses interval time.
   */
  keepAlive = () => {
    this.isActive = false;
    this.keepAliveCallback();
  };

  /**
   * Destroys the setInterval time.
   */
  destroy = () => {
    clearInterval(this.interval);
  };
}

export default SocketKeepAlive;
